export const ladders = [
  {
    title: "Seduced",
    oneLine: "You approach.",
    description:
      "You are in. You still feel like you belong to yourself, but you feel My sharp gaze. You may look away if you want. I won't.",
    tribute: 250,

    initiationVideoCall: "15 min. (approx.)",
    contact:
      "Telegram. You may initiate contact once a week. I reply when convenient.",
    access: "No weekend messaging",
    calls: "One 20-minute call per month",
    tasks: "2–3 light tasks per month",
    monitoring: "None",
    innerCircle: "Close Friends on Telegram",
    visibility: "No public visibility",
    priority: "Standard",
  },

  {
    title: "Surrendered",
    oneLine: "You begin to be seen.",
    description:
      "You are settling in. Under Me. This is no longer a fantasy. My presence lives inside you now, and you show up. Week after week, you show up. And from that, something grows.",
    tribute: 360,
    capacity: 5,
    occupied: 0,

    initiationVideoCall: "20 min. (approx.)",
    monitoring:
      "For short periods, when I deem you worthy, I enter your real life. A goal, a habit, a discipline, set by you or by Me. Regardless of whether it is related to kink or not. You report to Me. There are consequences when you fall short.",
    contact:
      "Limited Telegram (up to 3 messages per week initiated by you). I reply when convenient.",
    access: "No weekend messaging",
    calls: "One 30-minute call per month",
    tasks: "One light weekly task (on average). Monitored every Friday.",
    innerCircle: "Telegram private broadcast channel/statuses",
    visibility: "No FetLife or website visibility",
    priority: "Priority for in-person booking",
  },

  {
    title: "Owned",
    oneLine: "You are claimed.",
    description:
      "You are part of My days — and I am part of yours. I think of you. And sometimes, without warning, I make sure you know it. I know your goals. I know when you've fallen short. And you will know when you made Me proud. You answer to Me. And that transforms you, and how you move through the world.",
    tribute: 450,
    capacity: 4,
    occupied: 2,

    initiationVideoCall: "30 min. (approx.)",
    contact: "Telegram on weekdays only (unless specified otherwise)",
    access: "You must message daily; I respond when I choose",
    chooseOnePath:
      "A) Weekly 15–20 min calls OR B) Monitoring path with daily check-ins. Extra calls can be booked.",
    tasks: "1–2 simple tasks per week",
    monitoring: "Structured oversight depending on chosen path",
    innerCircle: "Telegram private broadcast channel/statuses",
    visibility:
      "Visible on website as “Owned” (using your alias). FetLife visibility at my discretion.",
    priority: "Early priority for in-person booking and touring",
    names: ["Alyx", "U.T."],
  },

  {
    title: "Subjugated",
    oneLine: "You are shaped.",
    description:
      "You have stopped pretending this is just something you do. It is something you are. I am inside your life completely: your goals, your failures, your private world. You are becoming. And we are both watching. Nothing is hidden from Me anymore. We wouldn't want it any other way.",
    tribute: 750,
    capacity: 3,
    occupied: 1,

    initiationVideoCall: "To be discussed",
    contact:
      "Telegram (no weekends unless I initiate), more frequent voice notes from me",
    access: "Daily ritual submissions",
    calls: "One 30+min videocall per week",
    tasks: "One bigger weekly task or 2 simple tasks per week",
    monitoring: "Long-term projects with daily proof",
    innerCircle: "Telegram private broadcast channel/statuses",
    longTermTraining:
      "Focused training/monitoring on topics like feminisation, pet-play, protocol",
    visibility:
      "Month 1: Under Consideration on FetLife + website (using your alias). After: Toy / Under Training / Subjugated (visible to friends only)",
    priority: "High priority for in-person booking and touring",
    names: ["perrito imbecile"],
  },

  {
    title: "Collared",
    oneLine: "You are entirely Mine.",
    description:
      "There is nothing left for you to surrender. I already have all of you. No reservations. No distance. No part of you that I have not conquered. You exist FOR Me. And from that, something rare and beautiful grows between us. Your devotion, meeting My sovereignty. Something just ours, on My terms. As always.",
    tribute: 1200,
    capacity: 2,
    occupied: 0,

    initiationVideoCall: "To be discussed",
    contact: "Full Telegram access, including weekends",
    access: "Daily rituals from you; reviewed at my discretion",
    calls: "One weekly call (30+min)",
    tasks: "Weekly discipline + monthly ritual assignment",
    monitoring: "Default chastity; structured monitoring chosen by me",
    innerCircle: "All private content + personalised rituals",
    longTermTraining:
      "Focused training/monitoring on topics like feminisation, pet-play, protocol",
    visibility:
      "Mandatory test month as Under Consideration. After probation: Publicly listed as Collared on FetLife + website (using your alias)",
    priority: "Highest priority for in-person or online time",
    names: [],
  },
];
